export default "__VITE_ASSET__DIjV5SGI__"